goog.provide('el8.appchart.nonvisitNote.main');

goog.require('el8.appservice.notifier');
goog.require('el8.model.AjaxQueue');
goog.require('el8.service.pageunload');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.nonvisitNote');
goog.require('el8.template.appshared.docTags');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.uiwidget.deleteConfirm');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');
goog.require('el8.util.datecompare');
goog.require('el8.util.string');
goog.require('el8.app.settings.genericOrder');



/**
 * This manages the UI for (all types of) nonvisit notes
 */
el8.appchart.nonvisitNote.main = (function() {

    /*
     * Note that this nonvisit note UI is meant to support a single large
     * textarea and referenced documents.  It does not support bullets and/or
     * documents referenced to specific bullets
     */

    return {

        _init: function() {

            var that = this;

            this._associatedDocIdMap = {};

            this._currDateTime = null;

            /**
             * Setting up the dialog and the form
             */
            this._dialog = new el8.uiwidget.FormDialog({
                title: el8.template.appchart.nonvisitNote.title({
                    noteDate: el8.service.tz.soyStr(that._model.getDocumentDate()),
                    noteTypeName: that._model.getNoteTypeName()
                }),
                width: 510,
                autoHeight: true,
                contentFn: function() {
                    return el8.template.appchart.nonvisitNote.formContent({
                        // Sleep to Generic order UI reskin
                        sleepOrderTitle: el8.app.settings.genericOrder().getLabel('Order', 'Sleep')
                    });
                },
                closeFn: function() {
                    that.saveDraftNote();
                }
            });
            var noteFieldSelector = ':input[name="notes"]';
            this._form = new el8.uiwidget.Form({
                fields: [
                    {
                        name: 'notes',
                        selector: noteFieldSelector,
                        type: 'input',
                        infoText: 'notes...',
                        height: 6*el8.util.consts.DEFAULT_FIELD_HEIGHT
                    }
                ]
            });
            this._form.addButton('sign', 'Sign Note', function(_form) {
                that.signNote();
            }, true);
            this._form.addButton('save-draft', 'Save as Draft & Close', function(_form) {
                that.saveDraftNote();
            });
            this._form.addDiscardButton(function(_form) {
                that.cancelFn();
            });

            this._dialog.setForm(this._form);

            /**
             * Call show here because it's needed for the rest to flow
             */
            this._dialog.show();

            /**
             * Initialize triggers
             */
            var dialogContainer = this._dialog.getDialogContainer();

            dialogContainer.on('change', noteFieldSelector, function() {
                that.saveText();

            }).on('click', '.details-trigger',  function() {
                var docId = $(this).attr('data-id')*1;
                el8.appchart.showItemDetail(docId);
                return false;

            }).on('click', '.remove-assoc-doc-trigger',  function() {
                var docId = $(this).attr('data-id')*1;
                that._model.unassociateDoc(docId, function() {
                    that._removeAssociatedDocument(docId);
                });

            }).on('click', '.remove-owned-doc-trigger',  function() {
                var docId = $(this).attr('data-id')*1;
                var item = el8.ptdata.fetchById(docId);
                if ( (item.is('MedOrder') && item.isDocumentMed()) || item.is('ReferralOrder') ) {
                    el8.appchart.dialog.removeOrder.show(that._model, item,
                        function() {
                            // Disown document
                            that._model.unassociateDoc(item.getId(), function() {
                                that.removeNewOrder(item);
                                el8.appchart.mainFeeds.chart.update();
                            });
                        }
                    );
                } else {
                    el8.uiwidget.deleteConfirm("order",
                        function() {
                            var entitySet = el8.ptdata.getEntitySet(item.getModelClass());
                            entitySet.deleteItem(item);
                        }
                    );
                }

            }).on('click', '.remove-vital-trigger',  function() {
                var docId = $(this).attr('data-id')*1;
                el8.uiwidget.deleteConfirm("set of vitals",
                    function() {
                        var vc = el8.ptdata.vitalsCollections.getById(docId);
                        el8.ptdata.vitalsCollections.deleteItem(vc, false, {
                            successCb: function() {
                                that._removeDisplayVital(docId);
                                $(document).trigger('el8_noteVitalUpdate');
                            }
                        });
                    }
                );

            }).on('click', '.nonvisit-date-clickable',  function(e) {
                e.preventDefault();
                var noteType = el8.data.nonvisitNoteTypes.getById(that._model.getNoteTypeId());
                noteType = (noteType) ? noteType.getName().capitalize() : 'Nonvisit';
                el8.appchart.dialog.setDateTime.show({
                    defaultDateTime: that._model.getDocumentDate(),
                    saveCallbackFn: function(newDateTime) {
                        $('#nonvisit-date', dialogContainer).text(newDateTime.asDateTimeString());
                        that._currDateTime = newDateTime;
                        that.saveDocumentDate();
                    },
                    title: 'Set '+ noteType +' Note Date and Time'
                });
            }).on('click', '.add-edit-tags-trigger',  function () {
                el8.appchart.dialog.docTags.show({
                    doc: that._model,
                    successCb: function() { that._populateDocTagsWithTooltips(); }
               });
                return false;
            });

            if (el8Globals.FEATURES.MUReports) {
                dialogContainer.on('click', ':input[name="isPatientReminder"]',
                    function() {
                        var typeVal = $(this).val();
                        that._model.updateMeaningfulUseInfo({is_patient_reminder: (typeVal*1 === 1)});
                    }
                );
                el8.uiwidget.collapsible({
                    container: $('.mu-info-body', dialogContainer),
                    triggerElt: $('.mu-info-header', dialogContainer),
                    statusElt: $('.mu-info-status', dialogContainer),
                    isCollapsed: true,
                    expandFn: function() {
                        $('.dialog-content', dialogContainer).scrollTo('100%');
                        that._dialog.adjustHeight();
                    },
                    collapseFn: function() {
                        that._dialog.adjustHeight();
                    }
                });
            }

            dialogContainer.on('change', ':input[name="confidential"]',  function() {
                var newConfidentiality = $(this).is(':checked');
                that._model.saveConfidentiality(newConfidentiality);
            });

            /**
             * Setup auto-saving
             */
            // If somebody accidentally closes the window
            el8.service.pageunload.add(function() {
                that._unloadBlurAll();
                that._saveIfDirty();
            });
        },

        _saveIfDirty: function() {

            if (!this._isOpen) { return; }

            // Check if the text needs saving and save _synchronously_ if so
            if (this._Q.isQueueDirty('text')) {
                this.saveText(false);
            }

            // Check if date needs saving (also synchronous)
            if (this._Q.isQueueDirty('docDate')) {
                this.saveDocumentDate(false);
            }
        },

        _populateDocTagsWithTooltips: function () {
            var docTagMaps = this._model.getDocTagMaps();
            var $elt = this._dialog.getDialogContainer();

            if (docTagMaps) {
                $('.doctags', $elt).html(
                    el8.template.appshared.docTags.docTagsLine({ docTags: docTagMaps })
                );
                this._dialog.adjustHeight();

                _(docTagMaps)
                    .chain()
                    .filter(function(docTag) { return docTag.code; })
                    .each(function (docTag) {
                        el8.service.tooltip.create({
                            anchor: $elt.find("span[data-id='" + docTag.id + "']").first(),
                            text: el8.template.appshared.docTags.tooltip({ docTag: docTag }),
                            placement: 'bottom',
                            theme: 'dark'
                        });
                    })
                    .value();
            }
        },

        _destroyDocTagTooltips: function () {
            _(this._dialog.getDialogContainer().find('.doctag-coded.has-tippy')).each(function (span) {
                el8.service.tooltip.destroy($(span));
            });
        },

        _prePopulate: function() {
            this._form.enable();
            this._currDateTime = this._model.getDocumentDate();
            var text = this._model.getBulletSet().asSingleField();
            this._form.setVal('notes', text);
            if (this._model.getAssociatedDocuments().length) {
                for (var i=0; i<this._model.getAssociatedDocuments().length; i++) {
                    var curr = this._model.getAssociatedDocuments()[i];
                    this._displayAssociatedDocument(curr);
                }
            } else {
                $('.associated-documents-container', this._dialog.getContentElt()).hide();
            }
            if (this._model.getOwnedDocuments().length) {
                for (var i=0; i<this._model.getOwnedDocuments().length; i++) {
                    var curr = this._model.getOwnedDocuments()[i];
                    this._displayOwnedDocument(curr);
                }
            } else {
                $('.owned-documents-container', this._dialog.getContentElt()).hide();
            }
            if (this._model.getVitalsCollections().length) {
                for (var i=0; i<this._model.getVitalsCollections().length; i++) {
                    var curr = this._model.getVitalsCollectionObjects()[i];
                    this._displayVital(curr.asSoyMap());
                }
            } else {
                $('.vitals-container', this._dialog.getContentElt()).hide();
            }
            if (this._model.getMeaningfulUseInfoItem('isPatientReminder')) {
                $(':input[name="isPatientReminder"][value="1"]', this._dialog.getContentElt()).prop('checked', true);
            } else {
                $(':input[name="isPatientReminder"][value="0"]', this._dialog.getContentElt()).prop('checked', true);
            }

            this._populateDocTagsWithTooltips();

            $(':input[name="confidential"]', this._dialog.getContentElt()).prop('checked', this._model.isConfidential());

        },

        show: function(note) {
            if (this._isOpen) { return; }

            this._isOpen = true;

            this._Q = new el8.model.AjaxQueue();

            this._model = note;
            this._init();

            this._prePopulate();
            this._form.initFocus();

            /**
             * There is a limitation in AjaxQueue that allows for misbehavior if the very 1st and 2nd
             * calls to saveText() happen rapidly in succession (i.e. if 2nd goes off before 1st request
             * calls back).  Specifically, this will cause two bullets to be created even though this
             * form only has ONE FIELD.
             *
             * Therefore, here we always initialize the note with 1 bullet (assuming ONE FIELD)
             */
            if (!this._model.getBulletSet().all().length) {
                var that = this;
                this.saveText(false, function() {
                    el8.ptdata.nonvisitNotes.trigger(EVENTS.UPDATED, that._model);
                });
            }

            this._dialog.adjustHeight();

        },

        hide: function() {
            if (!this._dialog) { return; }
            this._destroyDocTagTooltips();
            this._dialog.hide();
            this._dialog.destroy();
            this._dialog = null;
        },

        cancelFn: function() {
            var that = this;
            if (!this._model || this._model.isSignedOff()) {
                that.hide();
                that.reset();
            } else {
                this.deleteNote(function() {
                    that.hide();
                    that.reset();
                });
            }
        },

        reset: function() {
            this._model = null;
            this._isOpen = false;
            this._associatedDocIdMap = {};
            this._Q = null;
        },

        addReference: function(opts) {

            if (!this._isOpen) { return; }

            var that = this;
            var documentId = null,
                labResultId = null,
                patientItemId = null;

            opts = opts || {};
            var item = opts.item;
            var text = opts.text || null;

            switch(item.getModelClass()) {
                case 'PatientDrugIntolerance':
                case 'PatientAllergy':
                case 'PatientProblem':
                case 'PatientHistoryItem':
                case 'PatientSmokingStatus':
                case 'PatientImmunization':
                case 'PatientImmunizationDecline':
                case 'PatientFamilyHistoryItem':
                    patientItemId = item.getId();
                    break;
                case 'DiscontinueMedOrder':
                case 'MedOrder':
                    documentId = item.getId();
                    break;
                case 'LabResult':
                    labResultId = item.getId();
                    documentId = item.getReportId();
                    break;
                case 'MedOrderThread':
                    documentId = item.getLatestOrderId();
                    break;
                default: // includes 'Report'
                    documentId = item.getId();
                    break;
            }

            if (documentId && !labResultId) {
                if (text) { this.addText(text); }
                this.associateDoc(documentId, null, function(data) {
                    that._displayAssociatedDocument(data);
                });
            }
            if (labResultId) {
                this.addText(text || item.getNoteSummary());
                this.associateDoc(documentId, labResultId, function(data) {
                    that._displayAssociatedDocument(data);
                });
            }
            if (patientItemId) {
                this.addText(text || item.getNoteSummary());
                this.associateItem(patientItemId);
            }
        },

        addText: function(text) {
            if (!this._isOpen) { return; }
            var currVal = this._form.getVal('notes');
            var newVal = currVal ? currVal + '\n' + text : text;
            this._form.setVal('notes', newVal);
            this.saveText();
        },

        addProblemSubBullet: function(item, text) {
            this.addReference({item: item, text: text});
        },

        _removeDisplayBullet: function(docTypeString, docId) {
            // Remove this bullet
            var container = $('.'+docTypeString+'-section', this._dialog.getContentElt());
            container.find('[data-id="'+docId+'"]')
                .parent('li').remove();
            if (!$('li', container).length) {
                $('.'+docTypeString+'-container', this._dialog.getContentElt()).hide();
            }
            this._dialog.adjustHeight();
        },

        _displayAssociatedDocument: function(noteDoc) {
            if (!this._associatedDocIdMap[noteDoc['document_id']]) {
                $('.associated-documents-container', this._dialog.getContentElt()).show();
                $('.associated-documents-section', this._dialog.getContentElt()).append(
                    el8.template.appchart.nonvisitNote.associatedDocument({
                        docId: noteDoc['document_id'],
                        summary: noteDoc['summary'],
                        summaryFormatting: noteDoc['summary_formatting']
                    })
                );
                this._associatedDocIdMap[noteDoc['document_id']] = true;
            }
            this._dialog.adjustHeight();
        },
        _removeAssociatedDocument: function(docId) {
            this._removeDisplayBullet('associated-documents', docId);
        },

        _displayOwnedDocument: function(noteDoc) {
            $('.owned-documents-container', this._dialog.getContentElt()).show();
            $('.owned-documents-section', this._dialog.getContentElt()).append(
                el8.template.appchart.nonvisitNote.ownedDocument({
                    docId: noteDoc['document_id'],
                    summary: noteDoc['summary'],
                    summaryFormatting: noteDoc['summary_formatting']
                })
            );
            this._dialog.adjustHeight();
        },
        _removeDisplayOwnedDocument: function(docId) {
            this._removeDisplayBullet('owned-documents', docId);
        },

        _displayVital: function(vitalMap) {
            $('.vitals-container', this._dialog.getContentElt()).show();
            $('.vitals-section', this._dialog.getContentElt()).append(
                el8.template.appchart.nonvisitNote.vital(vitalMap)
            );
        },
        _removeDisplayVital: function(docId) {
            this._removeDisplayBullet('vitals', docId);
        },
        _numDisplayedVitals: function() {
            return $('.vitals-section', this._dialog.getContentElt()).children().length;
        },

        addNewOrder: function(order) {
            if (!this._isOpen) { return; }
            var noteDoc = this._model.addOwnedDocument(order);
            this._displayOwnedDocument(noteDoc);
            el8.appservice.notifier.notify(order.getNotifyText('ADD_TO_NOTE'));
        },

        removeNewOrder: function(order) {
            if (this._model) {
                this._model.removeOwnedDocument(order);
                this._removeDisplayOwnedDocument(order.getId());
            }
        },

        addNewVital: function(vital) {
            if (!this._isOpen) { return; }
            this._model.setVitalsCollections(this._model.getVitalsCollections().concat(vital));
            this._displayVital(vital.asSoyMap());
            el8.appservice.notifier.notify('Vitals added to note.');
        },

        deleteNote: function(callbackFn) {
            var that = this;
            that._form.disable();
            el8.uiwidget.deleteConfirm('note',
                function() {
                    el8.appservice.notifier.notify(
                        that._model.getNotifyText('DELETE_IN_PROGRESS'));
                    el8.ptdata.nonvisitNotes.deleteItem(that._model, false, {
                        successCb: function() {
                            el8.appservice.notifier.notify(
                                that._model.getNotifyText('DELETE_COMPLETE'));
                            if (callbackFn) { callbackFn(); }
                        },
                        errorCb: function() {
                            that._form.enable();
                        }
                    });
                },
                function() {
                    that._form.enable();
                }
            );

        },

        signNote: function() {
            var that = this;

            that._saveIfDirty(); // just in case

            that._form.disable();
            var note = that._model;
            note.setOnHold(false);
            el8.appservice.notifier.notify(note.getNotifyText('SAVE_IN_PROGRESS'));

            this._Q.doFinalAjax({
                url: el8Globals['PATIENT_PATH']+'nonvisit-notes/'+note.getId()+'/sign/',
                type: 'POST',
                success: function(data) {
                    note.populate(data);
                    el8.ptdata.nonvisitNotes.addOrUpdate(note);
                    el8.appservice.notifier.notify(
                        note.getNotifyText('SAVE_COMPLETE'));
                    that.hide();
                    that.reset();
                },
                error: function() { that._form.enable(); }
            }, function() {
                el8.uiwidget.alert('There has been an error, and the non-visit note cannot be saved. Please copy your text to a different program and try to create this note again.');
                that._form.enable();
            });
        },

        saveDraftNote: function() {
            var that = this;
            that._saveIfDirty();
            that.hide();
            that.reset();
            return true;
        },

        saveDocumentDate: function(async) {

            if (el8.util.datecompare.isSameDay(this._model.getDocumentDate(), this._currDateTime) &&
                el8.util.datecompare.isSameTime(this._model.getDocumentDate(), this._currDateTime)) {
                    // Don't save if date hasn't changed
                    return;
            }

            /**
             * Not using nonvisit note's saveDocumentDate method because we want
             * to use AjaxQueue
             */
            var that = this;
            this._Q.doAjax('docDate', {
                type: 'POST',
                async: async,
                url: el8.service.urls.get('nonvisitNoteDate', [that._model.getId()]),
                data: {data: JSON.stringify({
                    'document_date': el8.service.tz.asServerFormatDateTime(that._currDateTime)
                })},
                success: function(data) {
                    that._model.setDocumentDate(that._currDateTime);
                    that._model.setChartFeedDate(that._currDateTime);
                    el8.ptdata.nonvisitNotes.trigger(EVENTS.UPDATED, that._model);
                },
                error_msg: function(_status, default_msg) {
                    if (_status === 409) {
                        return "This note was updated in another window. Please refresh the page to get the updates.";
                    }
                    return default_msg;
                }
            });

        },

        saveText: function(async, successCb) {

            // Assume that there is only one textarea
            var bulletSet = this._model.getBulletSet();
            var item = bulletSet.all().length ?
                bulletSet.all()[0] : bulletSet.create({});

            /**
             * Because we set the text here, we can't rely on any text comparison
             * that will allow us to save text only if it changes
             */
            // emoji / other 4-byte chars break MySQL, so kill those
            var originalText = this._form.getVal('notes');
            var cleanedText = el8.util.string.cleanMultiByteChars(originalText);
            // being super conservative and updating the value in the form and then re-retrieving
            // from the form before saving so what's saved is definitely what the user is seeing
            if (originalText !== cleanedText) {
                this._form.setVal('notes', cleanedText);
            }
            item.setText(this._form.getVal('notes'));
            item.setSequence(0);
            var existingBulletVersion = item.getVersion() || 0;

            this._Q.doAjax('text', {
                type: 'POST',
                url: el8.service.urls.get('nonvisitNoteBullet', [item]),
                async: async,
                data: {data: JSON.stringify(item.asMap())},
                success: function(data) {
                    item.populate(data);
                    bulletSet.add(item, false);
                    bulletSet.sorted();
                    el8.appservice.notifier.notify('Note draft saved.');
                    if (successCb) { successCb(); }
                },
                error_msg: function(_status, default_msg) {
                    if (_status === 409) {
                        return "This note was updated in another window. Please refresh the page to get the updates.";
                    }
                    return default_msg;
                }
            });

            if (async !== false) {
                // Eagerly update the bullet version so that if we personally initiate multiple
                // concurrent saves, the last one issued takes precedence (instead of creating
                // duplicates). Since we had knowledge of all the data, that should be ok.
                item.setVersion(existingBulletVersion + 1);
            }

        },

        associateDoc: function(docId, labResultId, successCb) {
            // Mimics associateDoc method in nonvisit.js
            // Needed because of the AjaxQueue here
            var doc = el8.ptdata.fetchById(docId);
            var data = {'summary': doc.getNoteSummary()};
            if (labResultId) {
                data['lab_result_id'] = labResultId;
            }
            var that = this;
            this._Q.doAjax('text', { // queue up with the text field
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+'nonvisit-notes/'+that._model.getId()+'/referenced_docs/'+docId+'/',
                data: {'data': JSON.stringify(data)},
                success: successCb
            });
        },

        associateItem: function(itemId, successCb) {
            // Mimics associateItem method in nonvisit.js
            var that = this;
            this._Q.doAjax('text', { // queue up with the text field
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+'nonvisit-notes/'+that._model.getId()+'/referenced_items/'+itemId+'/',
                success: successCb
            });
        },

        isOpen: function() { return Boolean(this._isOpen); },

        getOpenNoteId: function() {
            if (!this._isOpen || !this._model) { return null; }
            return this._model.getId();
        },

        _unloadBlurAll: function() {
            if (this._isOpen) {
                $(':input', this._dialog.getDialogContainer()).blur();
            }
        }

    };

})();
